<template>
	<!-- Linha única de navegação entre as telas do cadastro. Quando os botões não cabem, a barra
	     rola na horizontal em vez de quebrar linha (antes as linhas encavalavam sem espaço). -->
	<nav
		ref="bar"
		class="container__subheaderbuttons__buttons"
	>
		<div
			v-for="(labelAndLinkNameIndividual, key) in labelAndLinkName"
			:key="key"
			:ref="`item-${labelAndLinkNameIndividual.linkName}`"
			class="container__subheaderbuttons__buttons__group"
		>
			<Button
				class="container__subheaderbuttons__buttons__group__item"
				color="trv-primary"
				semantic-class="mini"
				width-auto
				:label="labelAndLinkNameIndividual.label"
				:outlined="activeRoute !== labelAndLinkNameIndividual.linkName"
				@click="changeRoute(labelAndLinkNameIndividual.linkName)"
			/>
		</div>
	</nav>
</template>

<script>
import Button from '../Button/Button'
export default {
	components: { Button },
	props: {
		activeRoute: String,
		changeRoute: Function,
		labelAndLinkName: Array,
	},
	watch: {
		activeRoute() {
			this.$nextTick(this.scrollActiveIntoView)
		},
	},
	mounted() {
		this.scrollActiveIntoView()
	},
	methods: {
		// Com a barra rolando, garante que o botão da tela atual fique visível. Mexe só no
		// scrollLeft da barra: scrollIntoView também rolaria a página na vertical.
		scrollActiveIntoView() {
			const bar = this.$refs.bar
			const refs = this.$refs[`item-${this.activeRoute}`]
			const item = Array.isArray(refs) ? refs[0] : refs
			if (!bar || !item) return
			const start = item.offsetLeft - bar.offsetLeft
			const end = start + item.offsetWidth
			if (start < bar.scrollLeft) bar.scrollLeft = start
			else if (end > bar.scrollLeft + bar.clientWidth) bar.scrollLeft = end - bar.clientWidth
		},
	},
}
</script>

<style scoped>
.container__subheaderbuttons__buttons {
	display: flex;
	flex-wrap: nowrap;
	gap: 0.5rem;
	width: 100%;
	margin-top: 0.75rem;
	/* folga para o translateY do hover não ser cortado pelo overflow */
	padding: 0.25rem 0 0.5rem;
	overflow-x: auto;
	scrollbar-width: thin;
}

.container__subheaderbuttons__buttons__group {
	flex-shrink: 0;
}

.container__subheaderbuttons__buttons__group__item {
	margin: 0;
	white-space: nowrap;
}

@media screen and (min-width: 992px) {
	.container__subheaderbuttons__buttons__group__item.outlined {
		transition: transform 0.2s ease-in-out;
	}

	.container__subheaderbuttons__buttons__group__item.outlined:hover {
		transform: translateY(-0.2rem);
	}
}
</style>
